import { render, staticRenderFns } from "./cargando.vue?vue&type=template&id=d67fda1e&scoped=true"
import script from "./cargando.vue?vue&type=script&lang=js"
export * from "./cargando.vue?vue&type=script&lang=js"
import style0 from "./cargando.vue?vue&type=style&index=0&id=d67fda1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67fda1e",
  null
  
)

export default component.exports